import React from 'react'
import propTypes from 'prop-types'
import Popper from '@material-ui/core/Popper'
import Paper from '@material-ui/core/Paper'
import Fade from '@material-ui/core/Fade'
import {prefix} from 'helpers/component'
import {
  getTooltipArrow,
  getContainerClassName,
  ADJUST_INNER_TOOLTIP_PADDING,
} from 'helpers/ui'
import './hint.scss'

const getStyles = (small, width, bottom) => {
  return {
    width: width ? `${width}px` : 'auto',
    marginTop: bottom && `14px`,
    fontSize: small ? 11 : 13,
    padding: small ? 6 : 24,
  }
}

const getClassName = prefix('hint-')

const Hint = ({label, anchor, visible, small, animated, light, tooltip, width, hasPointer, zIndex}) => {
  const placementDefault = 'bottom-start'
  const {
    arrowLeft,
    arrowRight,
    targetOrigin,
    placement,
  } = getTooltipArrow(anchor, visible, tooltip, width, hasPointer)

  const bottom = targetOrigin?.vertical === 'bottom'

  const labelStyle = {
    width: `${width - ADJUST_INNER_TOOLTIP_PADDING}px`,
    alignItems: bottom && 'flex-end',
  }

  const labelWithArrows = (
    <div className={'label-with-arrow'} style={labelStyle}>
      {arrowLeft}
      {label}
      {arrowRight}
    </div>
  )
  const containerClassName = getContainerClassName(tooltip, light)

  // The arrow paints its own background, so the popover behind it goes transparent.
  const className = hasPointer
    ? `${getClassName(containerClassName)} ${getClassName('container-with-arrow')}`
    : getClassName(containerClassName)

  return (
    <Popper
      anchorEl={anchor}
      open={visible}
      placement={tooltip || hasPointer ? placement : placementDefault}
      style={{zIndex: zIndex || 2100}}
      transition>
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={animated ? 200 : 0}>
          <Paper className={className} elevation={1} style={getStyles(small, width, bottom)}>
            {hasPointer ? labelWithArrows : label}
          </Paper>
        </Fade>
      )}
    </Popper>
  )
}

Hint.propTypes = {
  label: propTypes.any,
  anchor: propTypes.object,
  visible: propTypes.bool,
  small: propTypes.bool,
  animated: propTypes.bool,
  light: propTypes.bool,
  tooltip: propTypes.bool,
  width: propTypes.number,
  hasPointer: propTypes.bool,
  zIndex: propTypes.number,
}

Hint.defaultProps = {
  visible: false,
  small: false,
  animated: false,
  light: false,
  tooltip: false,
  hasPointer: false,
}

Hint.contextTypes = {
  muiTheme: propTypes.object,
}

export default Hint
